import React, { useEffect, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";

function Ofertas({ user, setVisivel }) {
  const [tab, setTab] = useState("rascunhos");
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [criando, setCriando] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const currentId = urlParams.get("id");

  const carregarVideos = useCallback(() => {
    if (!user?.id) return;
    setLoading(true);
    fetch(`https://videooferta.com/api/listar-videos-usuario.php?id_user=${user.id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.sucesso && Array.isArray(data.videos)) {
          setVideos(data.videos);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [user?.id]);

  useEffect(() => {
    carregarVideos();
  }, [carregarVideos]);

  const rascunhos = videos.filter(
    (v) => v.video_status !== "done" || !v.video_url
  );
  const exportadas = videos.filter(
    (v) => v.video_status === "done" && v.video_url
  );

  const lista = tab === "rascunhos" ? rascunhos : exportadas;

  const handleCriarNovo = async () => {
    if (!user?.id || criando) return;
    setCriando(true);
    try {
      const res = await fetch("https://videooferta.com/api/criar-video.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id_user: user.id, formato: "story" }),
      });
      const data = await res.json();
      if (data?.success && data?.id_publico) {
        window.location.href = `/?id=${encodeURIComponent(data.id_publico)}`;
      }
    } catch {
      // ignore
    } finally {
      setCriando(false);
    }
  };

  const abrirVideo = (idPublico) => {
    window.location.href = `/?id=${encodeURIComponent(idPublico)}`;
  };

  const formatarData = (dataStr) => {
    if (!dataStr) return "";
    try {
      const d = new Date(dataStr);
      return d.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch {
      return dataStr;
    }
  };

  return (
    <div className="ofertas-panel">
      {/* Header */}
      <div className="ofertas-header">
        <div>
          <h5 className="ofertas-title">Minhas Ofertas</h5>
          <p className="ofertas-subtitle">Gerencie seus vídeos</p>
        </div>
      </div>

      {/* Tabs */}
      <div className="ofertas-tabs">
        <button
          className={`ofertas-tab${tab === "rascunhos" ? " ofertas-tab--active" : ""}`}
          onClick={() => setTab("rascunhos")}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
          Ofertas
        </button>
        <button
          className={`ofertas-tab${tab === "exportadas" ? " ofertas-tab--active" : ""}`}
          onClick={() => setTab("exportadas")}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Exportadas
        </button>
      </div>

      {/* Content */}
      <div className="ofertas-content">
        {loading ? (
          <div className="ofertas-loading">
            <div className="ofertas-spinner" />
            <span>Carregando...</span>
          </div>
        ) : (
          <div className="ofertas-grid">
            {/* Card de criar nova oferta */}
            {tab === "rascunhos" && (
              <motion.button
                className="ofertas-card ofertas-card--new"
                onClick={handleCriarNovo}
                disabled={criando}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25 }}
              >
                <div className="ofertas-card-new-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                </div>
                <span className="ofertas-card-new-label">
                  {criando ? "Criando..." : "Nova oferta"}
                </span>
              </motion.button>
            )}

            {/* Cards de vídeos */}
            <AnimatePresence>
              {lista.map((video, i) => (
                <motion.button
                  key={video.video_id}
                  className={`ofertas-card${video.id_publico === currentId ? " ofertas-card--current" : ""}`}
                  onClick={() => abrirVideo(video.id_publico)}
                  whileHover={{ scale: 1.03 }}
                  whileTap={{ scale: 0.97 }}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.25, delay: i * 0.04 }}
                >
                  {/* Thumbnail */}
                  <div className="ofertas-card-thumb">
                    {video.tema_thumbnail ? (
                      <img
                        src={video.tema_thumbnail}
                        alt={video.tema_titulo || "Vídeo"}
                        className="ofertas-card-img"
                      />
                    ) : (
                      <div className="ofertas-card-placeholder">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="5 3 19 12 5 21 5 3" />
                        </svg>
                      </div>
                    )}

                    {/* Badge status */}
                    {video.id_publico === currentId && (
                      <span className="ofertas-badge ofertas-badge--current">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </span>
                    )}

                    {tab === "exportadas" && video.video_status === "done" && (
                      <span className="ofertas-badge ofertas-badge--done">
                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </span>
                    )}
                  </div>

                  {/* Info */}
                  <div className="ofertas-card-info">
                    <span className="ofertas-card-name">
                      {video.tema_titulo || "Sem tema"}
                    </span>
                    <span className="ofertas-card-meta">
                      {formatarData(video.data_criacao)}
                    </span>
                  </div>
                </motion.button>
              ))}
            </AnimatePresence>

            {lista.length === 0 && tab === "exportadas" && (
              <div className="ofertas-empty">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#5C4A63" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" />
                  <path d="M9 11l3 3 3-3" />
                  <line x1="12" y1="14" x2="12" y2="7" />
                </svg>
                <span>Nenhum vídeo exportado</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Ofertas;
